@if (model?.data) {
<div class="overflow-hidden"
     style="border-radius: 12px;">
    <!-- page image-->
    <df-image-wrapper>
        <img class="w-12"
             [ratio]="'3/2'"
             [dfImage]="model?.data?.image || ''">
    </df-image-wrapper>
    <div class="w-12 center p-t p-r-5 p-l-5 p-b-3 bg-col-52">
        <!-- page tags -->
        @for (tag of tagCategories; track tag) {
        @if(tag.data?.name && tag.data?.url){
        <a class="inline-block col-1 bg-col-62 c1 p-l-2 p-r-2 p-a-1"
           style="border-radius: 12px;"
           [class.m-l-3]="!$first"
           [routerLink]="tag.data?.url || ''">{{tag.data?.name || ''}}</a>
        }
        }
        <!-- page name -->
        <h3 class="h4 m-t">{{model?.data?.name}}</h3>

        <!-- button -->
        <a class="m-t s1 inline-block link"
           [routerLink]="model?.data?.url || ''">
            {{'Read Article' | translate}}
        </a>
    </div>
</div>
}